import PejuangOnlineBanner from './routes/banner/PejuangOnlineBanner.vue';

const PejuangOnlineRoutes = [
  {
    path: '/pejuang-online-banner',
    name: 'PejuangOnlineBanner',
    component: PejuangOnlineBanner,
  },
];

export default PejuangOnlineRoutes;